import React, { Children } from 'react'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import Button from '@active/react-ui/Button'
import { func, string, node } from 'prop-types'
import I18nMessage from '../I18nMessage'

function ProxyModalWithBodyDesc({
  children,
  desc,
  cancelText,
  okText,
  handleSubmit,
  handleCancel,
  ...rest
}) {
  return (
    <Modal {...rest}>
      <ModalBody>
        <div>
          {desc}
        </div>
        {children && Children.only(children)}
      </ModalBody>
      <ModalFooter>
        <Button
          type="strong"
          onClick={handleSubmit}
        >
          <I18nMessage id={okText} />
        </Button>
        {handleCancel && (
        <Button
          type="secondary"
          onClick={handleCancel}
        >
          <I18nMessage id={cancelText} />
        </Button>
        )}
      </ModalFooter>
    </Modal>
  )
}

ProxyModalWithBodyDesc.propTypes = {
  children: node,
  desc: node,
  cancelText: string,
  okText: string,
  handleSubmit: func.isRequired,
  handleCancel: func,
}
ProxyModalWithBodyDesc.defaultProps = {
  children: null,
  desc: null,
  cancelText: 'passport.common.btn.cancel',
  okText: 'passport.common.btn.submit',
  handleCancel: null,
}

export default ProxyModalWithBodyDesc
